

























import Vue from 'vue';
import { getContentArea } from '@/contentful';

interface Data {
  loading: boolean;
  content: boolean;
}

export default Vue.extend({
  name: 'confirm',
  data(): Data {
    return {
      loading: true,
      content: false,
    };
  },
  beforeMount() {
    getContentArea('account-overview-column-1').then((data) => {
      setTimeout(() => {
        if (data) {
          this.content = data.fields.fields;
        }
        this.loading = false;
      }, 1000);
    });
  },
});
